import VideoBox from './VideoBox';
import { VideoAsset } from '$Utilities/models/videoViews';
import { React } from 'Imports';

interface VideoSecondaryBarProps {
    videos: VideoAsset[];
    transitionEffect: boolean;
    height: number;
    itemClassName: string;
    onVideoDownloaded?: () => void;
}

const styles = require('./Layouts.scss') as {
    secondaryVideoBarContainer: string;
    secondaryVideoBarScroll: string;
};

const VideoSecondaryBar = (props: VideoSecondaryBarProps) => (
    <div
        className={styles.secondaryVideoBarContainer}
        style={{
            height: props.height,
            maxHeight: props.height,
        }}
    >
        <div className={styles.secondaryVideoBarScroll}>
            {props.videos.map((video, idx) => (
                <VideoBox
                    key={idx}
                    video={video}
                    transitionEffect={props.transitionEffect}
                    className={props.itemClassName}
                    onVideoDownloaded={props.onVideoDownloaded}
                />
            ))}
        </div>
    </div>
);

export default VideoSecondaryBar;
